import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  fill?: string;
};

const WorkordersIcon = ({ className, fill = "#2A2A2A" }: Props) => {
  return (
    <svg
      className={cn("h-4 w-4 shrink-0", className)}
      viewBox="0 0 16 16"
      fill={fill || "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
    <path
      d="M14 11.3333H13.3333V2.66667C13.3333 1.196 12.1373 0 10.6667 0H2.33333C1.04667 0 0 1.04667 0 2.33333V2.66667C0 3.76933 0.897333 4.66667 2 4.66667H3.33333V13.6667C3.33333 14.9527 4.37933 15.9993 5.666 16H13.6667C14.9533 16 16 14.9533 16 13.6667V13.3333C16 12.2307 15.1027 11.3333 14 11.3333ZM3.33333 3.33333H2C1.63267 3.33333 1.33333 3.034 1.33333 2.66667V2.33333C1.33333 1.782 1.782 1.33333 2.33333 1.33333C2.88467 1.33333 3.33333 1.782 3.33333 2.33333V3.33333ZM6.66667 13.3333V13.6667C6.66667 14.218 6.218 14.6667 5.66667 14.6667C5.11533 14.6667 4.66667 14.218 4.66667 13.6667V2.33333C4.66667 1.974 4.578 1.63733 4.43267 1.33333H10.6667C11.402 1.33333 12 1.93133 12 2.66667V11.3333H8.66667C7.564 11.3333 6.66667 12.2307 6.66667 13.3333ZM14.6667 13.6667C14.6667 14.218 14.218 14.6667 13.6667 14.6667H7.77467C7.91867 14.3633 8 14.0247 8 13.6667V13.3333C8 12.966 8.29933 12.6667 8.66667 12.6667H14C14.3673 12.6667 14.6667 12.966 14.6667 13.3333V13.6667Z"
      fill={fill}
    />
    </svg>
  );
};

export default WorkordersIcon;
